export function CasinoPlayerActivityAPIResponseFormatter(response) {
    if (!response.ok) {
        return Promise.reject(response.status);
    }
    return response
        .json()
        .then(data => data.casinoLastBetAgeInSeconds)
        .catch(e => e);
}
//# sourceMappingURL=CasinoPlayerActivityAPIResponseFormatter.js.map